// Team of the Week API client (TP_TOTW_BRIEF).
//
// Isolated from the shared services/api.js (small PR surface, no risk to the
// shared axios instance) — mirrors services/whatsNewService.js. Paths + shapes
// are the fixed BE contract (dashboard/totw_views.py, docs/totw_read_api.md),
// never guessed:
//   filters → GET /dashboard/totw/v1/filters/
//             { countries: [{ id, name, logo, competitions: [{ id, name, logo,
//               seasons: [{ id, year, rounds: [{ uuid, round, name }] }] }] }] }
//             League-only; levels without lineup data do not exist.
//   lineup  → GET /dashboard/totw/v1/lineup/?uuid=<id>
//             one lineup, players enriched server-side (photo, team, flags,
//             wyscout_id, on_platform, represented, agent_account_id).
//             rating is an INTEGER x100 (760 = 7.60) — the UI divides.
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_ENDPOINT;

const authApi = axios.create({ baseURL: API_BASE_URL, withCredentials: true });

// Same Bearer-token attachment the whats-new / scout-request clients use.
authApi.interceptors.request.use((config) => {
  try {
    const tokens = JSON.parse(localStorage.getItem("tokens") || "null");
    if (tokens?.access) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${tokens.access}`;
    }
  } catch (e) {
    /* no token — request proceeds and the server returns 401 */
  }
  return config;
});

const fail = (error) => ({
  success: false,
  status: error?.response?.status,
  error:
    error?.response?.data?.detail ||
    error?.response?.data?.message ||
    "Something went wrong. Please try again.",
});

export const totwService = {
  // The whole selection cascade in one call.
  getFilters: async () => {
    try {
      const res = await authApi.get("/dashboard/totw/v1/filters/");
      return { success: true, data: res.data };
    } catch (error) {
      return fail(error);
    }
  },

  // One enriched lineup by its uuid (from the cascade's round entries).
  getLineup: async (uuid) => {
    try {
      const res = await authApi.get("/dashboard/totw/v1/lineup/", {
        params: { uuid },
      });
      return { success: true, data: res.data };
    } catch (error) {
      return fail(error);
    }
  },
};

export default totwService;
